import { render, staticRenderFns } from "./AdminMailingList.vue?vue&type=template&id=0ad00e92&scoped=true"
import script from "./AdminMailingList.vue?vue&type=script&lang=js"
export * from "./AdminMailingList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ad00e92",
  null
  
)

export default component.exports